import Slider from "../../../../components/amirComponents/amirWhoWeAre/Slider";
import { Section3 } from "../../../../types/department";
interface Props {
  section3?: Section3;
}

const ChannelPartaner: React.FC<Props> = ({ section3 }) => {
  return (
    <>
      <section
        className="whowe-are  py-3 py-md-5"
        style={{ backgroundImage: `url(${section3?.image})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="hd-style-2  wow animate__fadeInLeft">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: section3?.heading ?? " ",
                  }}
                ></h2>
              </div>

              <div className="col-md-8 col-12">
                <Slider data={section3?.slider} />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 ">
              <div className="row justify-content-center justify-content-md-end">
                {section3?.content.map((step, index) => (
                  <div
                    key={index}
                    className="card-style1 my-2 col-12 wow animate__animated animate__slideInRight shadow-sm"
                  >
                    <div>
                      <svg
                        width="66"
                        height="65"
                        viewBox="0 0 66 65"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_412_205)">
                          <path
                            d="M33.0271 5.44629C35.1336 5.44642 37.1679 6.21375 38.7498 7.60483L39.1669 7.99754L41.0573 9.88796C41.5761 10.4034 42.2536 10.7288 42.9802 10.8115L43.3458 10.8332H46.0541C48.2674 10.833 50.3969 11.6797 52.0059 13.1995C53.6149 14.7194 54.5814 16.7972 54.7073 19.0069L54.7208 19.4998V22.2082C54.7208 22.9394 54.97 23.6517 55.4196 24.2205L55.6633 24.4913L57.551 26.3817C59.1157 27.9375 60.028 30.0315 60.102 32.2368C60.176 34.442 59.406 36.5925 57.9492 38.2496L57.5564 38.6667L55.666 40.5571C55.1506 41.0759 54.8252 41.7534 54.7425 42.48L54.7208 42.8457V45.554C54.7209 47.7673 53.8743 49.8968 52.3544 51.5057C50.8346 53.1147 48.7568 54.0812 46.5471 54.2071L46.0541 54.2207H43.3458C42.6156 54.2209 41.9067 54.467 41.3335 54.9194L41.0627 55.1632L39.1723 57.0509C37.6165 58.6155 35.5225 59.5279 33.3172 59.6018C31.112 59.6758 28.9615 58.9059 27.3044 57.449L26.8873 57.0563L24.9969 55.1659C24.478 54.6504 23.8006 54.3251 23.0739 54.2423L22.7083 54.2207H20C17.7867 54.2208 15.6572 53.3741 14.0482 51.8543C12.4393 50.3344 11.4727 48.2566 11.3469 46.0469L11.3333 45.554V42.8457C11.3331 42.1154 11.0869 41.4066 10.6346 40.8334L10.3908 40.5625L8.5031 38.6721C6.93845 37.1163 6.02612 35.0223 5.95214 32.8171C5.87816 30.6118 6.6481 28.4614 8.10498 26.8042L8.49768 26.3871L10.3881 24.4967C10.9035 23.9779 11.2289 23.3004 11.3116 22.5738L11.3333 22.2082V19.4998L11.3469 19.0069C11.4678 16.8821 12.3663 14.876 13.8713 13.3711C15.3762 11.8662 17.3822 10.9676 19.5071 10.8467L20 10.8332H22.7083C23.4385 10.8329 24.1474 10.5868 24.7206 10.1344L24.9914 9.89066L26.8819 8.00296C27.6871 7.19286 28.6446 6.54995 29.6992 6.11118C30.7539 5.67242 31.8848 5.44645 33.0271 5.44629ZM43.0398 25.1684C42.5319 24.6606 41.8431 24.3754 41.125 24.3754C40.4068 24.3754 39.7181 24.6606 39.2102 25.1684L30.2916 34.0842L26.7898 30.585L26.5352 30.3602C25.9908 29.9393 25.3067 29.7414 24.6217 29.8067C23.9367 29.8719 23.3022 30.1955 22.8471 30.7116C22.392 31.2277 22.1504 31.8977 22.1714 32.5855C22.1924 33.2732 22.4745 33.9272 22.9602 34.4146L28.3769 39.8313L28.6314 40.0561C29.1525 40.4603 29.8032 40.6605 30.4614 40.6191C31.1196 40.5777 31.7401 40.2976 32.2064 39.8313L43.0398 28.998L43.2646 28.7434C43.6688 28.2223 43.869 27.5716 43.8276 26.9134C43.7862 26.2552 43.5061 25.6347 43.0398 25.1684Z"
                            fill="#385986"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_412_205">
                            <rect
                              width="65"
                              height="65"
                              fill="white"
                              transform="translate(0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="sub-hd1">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: step ?? "",
                        }}
                      >
                        {/* {step} */}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChannelPartaner;
